export interface IQaRegistrationSetRegistrationStepResponse {
    data: {
        success: boolean,
        results: string
    }
}